export default function SvgSignOut() {
  return (
    <svg
      width="27"
      height="26"
      viewBox="0 0 24 23"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.5895 2.875H2.89844V20.125H11.5934"
        stroke="#F8F8F8"
        strokeWidth="1.58333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.0765 15.8125L7.729 11.5L12.0765 7.1875M20.2884 11.4962H7.729"
        stroke="#F8F8F8"
        strokeWidth="1.58333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
